import { render, staticRenderFns } from "./fullScreen.vue?vue&type=template&id=1f332126&scoped=true&"
import script from "./fullScreen.vue?vue&type=script&lang=js&"
export * from "./fullScreen.vue?vue&type=script&lang=js&"
import style0 from "./fullScreen.vue?vue&type=style&index=0&id=1f332126&prod&lang=less&scoped=true&"
import style1 from "./fullScreen.vue?vue&type=style&index=1&id=1f332126&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f332126",
  null
  
)

export default component.exports